import React from "react"

import { AnimatedModal } from "../../../../components/shared/Modal"

/**
 * ConfirmSaveModal - Modal de confirmación para guardar cambios o acciones destructivas
 * Se muestra cuando el usuario hace clic en "Save" o "Delete" para confirmar la acción
 *
 * @param {boolean} visible - Si el modal está visible
 * @param {function} onClose - Callback cuando el usuario cancela (No)
 * @param {function} onConfirm - Callback cuando el usuario confirma (Yes)
 * @param {string} actionButtonType - Tipo de botón para la acción (primary, destructive, etc.)
 */
const ConfirmSaveModal = ({
  visible,
  onClose,
  onConfirm,
  title = "Save changes?",
  message = "Are you sure you want to save these changes?",
  confirmLabel = "Yes",
  cancelLabel = "No",
  actionButtonType = "primary"
}) => {
  const isDestructive = actionButtonType === "destructive"

  return (
    <AnimatedModal
      visible={visible}
      hideModal={onClose}
      showFooter={false}
      hideCloseButton={false}
      dialogClassName="w-[560px] md:w-full p-0">
      {/* Header - Figma: pb-0 pt-[24px] px-[32px] */}
      <div className="flex items-start justify-between gap-4 px-8 pb-0 pt-6">
        <h2 className="flex-1 font-['Manrope:Bold',_sans-serif] text-[24px] font-bold leading-[32px] text-[#0b3954]">
          {title}
        </h2>
      </div>

      {/* Body - Figma: pb-[24px] pt-[16px] px-[32px] */}
      <div className="px-8 pb-6 pt-4">
        <div className="font-['Manrope:Regular',_sans-serif] text-[16px] font-normal leading-[24px] text-[#0b3954]">
          {message}
        </div>
      </div>

      {/* Footer with Border - Figma: p-[32px] border-t */}
      <div className="flex items-center justify-end gap-4 border-t border-[#e4eff6] p-8">
        <button
          onClick={onClose}
          className="flex items-center justify-center gap-2 rounded border border-[#c8d6df] bg-white px-4 py-1 transition-colors hover:bg-gray-50">
          <span className="text-nowrap font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[24px] text-[#0b3954]">
            {cancelLabel}
          </span>
        </button>
        <button
          onClick={onConfirm}
          className={`flex items-center justify-center gap-2 rounded px-4 py-1 transition-colors ${
            isDestructive ? "bg-[#eb5757] hover:bg-[#d64545]" : "bg-[#0d9da4] hover:bg-[#0b8a90]"
          }`}>
          <span className="text-nowrap font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[24px] text-white">
            {confirmLabel}
          </span>
        </button>
      </div>
    </AnimatedModal>
  )
}

export default ConfirmSaveModal
